const dummyStormData = {
	type: "FeatureCollection",
	features: [
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[-64.3359375, 23.885837699862005],
					[-56.953125, 25.16517336866393],
					[-53.4375, 28.92163128242129],
					[-47.4609375, 33.137551192346145],
					[-40.078125, 32.84267363195431],
					[-30.585937499999996, 37.996162679728116],
					[-23.203125, 42.032974332441405],
					[-18.984375, 37.71859032558816],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[-153.6328125, 2.4601811810210052],
					[-163.125, 3.8642546157214084],
					[-173.671875, 3.5134210456400448],
					[-179.6484375, 0.3515602939922709],
					[-190.546875, -0.7031073524364783],
					[-198.6328125, 1.4061088354351594],
					[-206.71874999999997, 7.36246686553575],
					[-214.45312499999997, 1.7575368113083254],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[-185.625, 31.353636941500987],
					[-175.4296875, 35.746512259918504],
					[-166.2890625, 37.71859032558816],
					[-157.5, 35.746512259918504],
					[-151.875, 31.653381399664],
					[-149.0625, 27.68352808378776],
					[-143.4375, 26.115985925333536],
					[-133.9453125, 30.751277776257812],
					[-127.61718749999999, 35.746512259918504],
					[-123.74999999999999, 36.87962060502676],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[-208.828125, 27.994401411046148],
					[-213.3984375, 22.917922936146045],
					[-222.890625, 23.563987128451217],
					[-227.4609375, 25.48295117535531],
					[-233.7890625, 30.751277776257812],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[0, -25.16517336866393],
					[8.0859375, -35.46066995149529],
					[14.765625, -40.713955826286046],
					[32.34375, -40.97989806962013],
					[41.484375, -36.87962060502676],
					[47.8125, -30.751277776257812],
					[59.0625, -27.371767300523032],
					[69.60937499999999, -30.145127183376115],
					[76.640625, -34.59704151614416],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[-35.15625, 62.59334083012024],
					[-29.53125, 59.88893689676585],
					[-21.09375, 59.17592824927136],
					[-9.4921875, 58.99531118795094],
					[-3.1640625, 60.413852350464914],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[85.078125, -4.214943141390639],
					[75.234375, -7.710991655433217],
					[65.7421875, 0],
					[61.87499999999999, 3.5134210456400448],
					[59.0625, 11.178401873711785],
				],
			},
		},
		{
			type: "Feature",
			properties: {},
			geometry: {
				type: "LineString",
				coordinates: [
					[-181.7578125, 55.57834467218206],
					[-175.078125, 53.12040528310657],
					[-163.828125, 52.482780222078226],
					[-156.09375, 54.36775852406841],
					[-149.4140625, 57.136239319177434],
					[-141.6796875, 56.75272287205736],
					[-137.109375, 55.178867663281984],
				],
			},
		},
	],
};

export default dummyStormData;
